import { Link } from 'react-router-dom';
import { allCategories, getVideosByCategory } from '@/lib/videos';

export default function CategoryEntries() {
  return (
    <section id="categories" className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
      <div className="mb-6 flex flex-col gap-1">
        <h2 className="text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
          按分类探索
        </h2>
        <p className="text-xs text-foreground-500 md:text-sm">
          从剧情长片到精选短片，再到深度专题，找到你感兴趣的方向。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {allCategories.map((category, index) => {
          const count = getVideosByCategory(category.key).length;
          const accent = index === 0 ? 'accent' : index === 1 ? 'primary' : 'secondary';
          return (
            <Link
              key={category.key}
              to={`/category/${category.key}`}
              className="group relative flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg ${
                  accent === 'accent'
                    ? 'bg-accent-100 text-accent-700'
                    : accent === 'primary'
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-secondary-100 text-secondary-800'
                }`}
              >
                <i className={`${category.icon} text-2xl`} />
              </span>
              <div>
                <h3 className="text-base font-bold text-foreground-950 md:text-lg">
                  {category.name}
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-500">
                  {category.description}
                </p>
              </div>
              <div className="mt-auto flex items-center justify-between pt-2">
                <span className="text-xs font-medium text-foreground-500">
                  共 {count} 部内容
                </span>
                <span className="flex items-center gap-1 text-sm font-medium text-primary-600">
                  进入分类
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
              <i
                className={`${category.icon} pointer-events-none absolute -right-4 -top-4 text-7xl opacity-[0.06]`}
              />
            </Link>
          );
        })}
      </div>
    </section>
  );
}